<template>
    <div>
        <div class="device-box r200-bg">
            <h3 class="device-name reveal-bottom">V100</h3>
            <p class="device-desc reveal-bottom">{{ $t("dv.rxv100t") }}</p>
            <img class="r200-img reveal-bottom" :src="r200" alt="r200" />
        </div>
        <div
            class="device-box bg-fixed"
            :style="{
                backgroundImage: 'url(' + bg2 + ')',
                height: '700px',
            }"
        >
            <div class="wrap">
                <div class="device-title reveal-bottom">
                    {{ $t("dv.rxv100t1") }}<br />
                    {{ $t("dv.rxv100t2") }}
                </div>
                <div class="device-char">
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro2"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd1") }}
                            </h4>
                            <div
                                style="font-size:20px;"
                                class="device-chart-desc-cont"
                            >
                                {{ $t("dv.rxv100") }}
                            </div>
                        </div>
                    </div>
                    <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro3"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd2") }}
                            </h4>
                            <div
                                style="font-size:20px;"
                                class="device-chart-desc-cont"
                            >
                                {{ $t("dv.rxv100") }}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="device-char-item reveal-bottom">
                        <img
                            :src="intro4"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd3") }}
                            </h4>
                            <div
                                style="font-size:20px;"
                                class="device-chart-desc-cont"
                            >
                                {{ $t("dv.rxno") }}
                            </div>
                        </div>
                    </div> -->
                    <!-- <div
                        class="device-char-item reveal-bottom"
                        style="width:250px"
                    >
                        <img
                            :src="intro6"
                            alt="intro1"
                            class="device-char-icon"
                            style="height:50px"
                        />
                        <div class="device-char-desc">
                            <h4 class="device-chart-desc-titl">
                                {{ $t("dv.rd4") }}
                            </h4>

                            <div
                                style="font-size:20px;"
                                class="device-chart-desc-cont"
                            >
                                {{ $t("dv.rxno") }}
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="device-box">
            <div class="card-box reveal-bottom">
                <div class="card  r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ry") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">1</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.rxv100u") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ru") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">2</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.rxv100") }}
                    </div>
                </div>
                <div class="card r200">
                    <div class="card-head">
                        <div class="card-head-left">
                            <span>{{ $t("dv.ra") }}</span>
                            <div></div>
                        </div>
                        <div class="card-no">3</div>
                    </div>
                    <div
                        class="card-text"
                        :style="lang === 'en_US' ? 'font-size:25px' : ''"
                    >
                        {{ $t("dv.rxv100a") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    name: "R200",
    data() {
        return {
            lang: localStorage.getItem("lang"),
            bg2: require("@/assets/images/devices/v100_bg.jpeg"),
            r200: require("@/assets/images/devices/v100.svg"),
            intro1: require("@/assets/images/devices/R200_intro1.png"),
            intro2: require("@/assets/images/devices/R200_intro2.png"),
            intro3: require("@/assets/images/devices/R200_intro3.png"),
            intro4: require("@/assets/images/devices/R200_intro4.png"),
            intro5: require("@/assets/images/devices/R200_intro5.png"),
            intro6: require("@/assets/images/devices/R200_intro6.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
        this.$bus.$on("lang", (lang) => {
            this.lang = lang;
        });
    },
};
</script>
<style scoped>
@import "./devices.css";
.r200-img {
    width: 400px;
    /* height: 496px; */
    margin: 45px auto 0;
    display: block;
}
.r200-bg {
    /* background: linear-gradient(left top, #004e92, #020b5e); */
    /* background: linear-gradient(left top, #152ae9, #004e92); */
    background: #fff;
}
.r200:hover {
    background-color: rgba(0, 163, 209, 1);
    transition: all 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Hardware/V100.vue